// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2373":"6530d77045a611e9","2888":"0f5b24dac4f14b11","6592":"6530d77045a611e9"}[chunkId] + ".css";
};